import { useState } from "react"

// Karten-Sichtzustand, den MyMapEvent befüllt (Zoom, Bounds, Drag/Resize)
// plus die Leaflet-Map-Instanz aus dem Container-Ref.
export function useMapViewState({ initialZoom }) {
  const [zoomLevel, setZoomLevel] = useState(initialZoom)
  const [dragged, setDragged] = useState(false) // switch/event callback!!!
  const [resized, setResized] = useState(0) // counter/event callback!!!
  const [mapBounds, setMapBounds] = useState(null)
  const [map, setMap] = useState(null)

  return {
    zoomLevel,
    setZoomLevel,
    dragged,
    setDragged,
    resized,
    setResized,
    mapBounds,
    setMapBounds,
    map,
    setMap,
  }
}
